import {request} from "./request";

export const getAvatarList = queryParams => {
  return request.get({
    path: "/engine/avatar/list",
    queryParams,
  });
};
